/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Paste_ConfirmInputs */

const en_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_context_menu_paste_confirm = /** @type {(inputs: Context_Menu_Paste_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Context_Menu_Paste_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_paste_confirm = /** @type {((inputs?: Context_Menu_Paste_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Paste_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_paste_confirm(inputs)
	if (locale === "de") return de_context_menu_paste_confirm(inputs)
	if (locale === "it") return it_context_menu_paste_confirm(inputs)
	if (locale === "ru") return ru_context_menu_paste_confirm(inputs)
	if (locale === "es") return es_context_menu_paste_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_paste_confirm(inputs)
	if (locale === "ja") return ja_context_menu_paste_confirm(inputs)
	if (locale === "hi") return hi_context_menu_paste_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_paste_confirm(inputs)
	return en_context_menu_paste_confirm(inputs)
});